/* Actions */
export const GET_REQUEST = "GET_REQUEST";
export const VALIDATE_POSTAL_CODE = "VALIDATE_POSTAL_CODE";

/* Mutations */
export const GET_REQUEST_SUCCESS = "GET_REQUEST_SUCCESS";
